export const FIGHTER_STATUSES = {
  actif: "Actif",
  indisponible: "Indisponible",
  blesse: "Blessé",
  fight_booked: "Fight booké",
  suspendu: "Suspendu",
  inactif: "Inactif",
  retraite: "Retraité",
  archive: "Archivé",
};

export const FIGHTER_GENDERS = {
  M: "Homme",
  F: "Femme",
};

export const CARD_SECTION_LABELS = {
  main_event: "Main Event",
  co_main: "Co-Main Event",
  main_card: "Main Card",
  prelims: "Prelims",
};

export const METHOD_LABELS = {
  KO: "KO",
  TKO: "TKO",
  Submission: "SUB",
  "Unanimous Decision": "DEC. UNANIME",
  "Split Decision": "DEC. PARTAGÉE",
  "Majority Decision": "DEC. MAJORITAIRE",
  Draw: "NUL",
  Disqualification: "DQ",
  "Doctor Stoppage": "ARRÊT MÉDECIN",
  "No Contest": "NC",
  Other: "AUTRE",
};

export const NAV_LINKS = [
  { to: "/", label: "Accueil", testId: "nav-accueil" },
  { to: "/events", label: "Événements", testId: "nav-events" },
  { to: "/fighters", label: "Combattants", testId: "nav-fighters" },
  { to: "/rankings", label: "Rankings", testId: "nav-rankings" },
  { to: "/live", label: "Live", testId: "nav-live" },
  { to: "/actualites", label: "Actualités", testId: "nav-news" },
  { to: "/rejoindre", label: "Rejoindre la ligue", testId: "nav-join" },
];
